<script>
    import {createEventDispatcher, onDestroy} from "svelte";
    import {searchFilter} from "../core/app-store.js";
    import {screensStore} from "../core/screens-manager.js";
    import {scrollToElementId} from "../core/utils.js";
    import { t } from '../core/i18n/language-store';
    const dispatch = createEventDispatcher();

    let searchText;

    function keyupHandler(e) {
        const searchText = (e.target?.value || '').trim().toLowerCase();
        searchFilter(searchText.length > 1 ? searchText : undefined);
    }

    function resetHandler() {
        searchText = '';
        searchFilter(undefined);
    }

    let _searchPanelOpened;
    const subscribes = [
        screensStore.subscribe(x => {
            if(x.searchPanelOpened !== _searchPanelOpened) {
                _searchPanelOpened = x.searchPanelOpened;
                if (!_searchPanelOpened) {
                    searchFilter(undefined);
                }
                else {
                    scrollToElementId('dm-menu');
                    setTimeout(() => document.getElementById('dm-search-field').focus());
                }
            }
        })
    ];


    onDestroy(() => {
        for (let i = 0; i < subscribes.length; i++){
            subscribes[i]();
        }
    });

</script>

<style>
.search-panel-container {
    padding: 1.5rem 0;
    position: relative;
}
.search-input,
.search-input::placeholder {
    font-size: inherit;
    font-family: inherit;
}
.search-input {
    border-radius: var(--order-input-border-radius);
    border: 1px solid var(--order-input-border-color);
    background: var(--order-input-bg-color);
    color: var(--order-input-text-color);
    box-shadow: 0 0 0 4px rgb(170 198 219 / 10%);
    padding: 0.625rem 0.875rem;
    width: 100%;
    text-transform: uppercase;
    outline: none;
    transition: background-color .25s ease, border-color .25s ease, box-shadow .25s ease;
}
.search-input:focus {
    border-color: var(--accent-color);
    box-shadow: 0 0 0 4px var(--accent-color-semi);
    _background-color: var(--accent-color-semi);
}
.search-input::placeholder {
    color: var(--order-input-placeholder-color);
    text-transform: uppercase;
}
.reset-button {
    position: absolute;
    top: 0;
    right: 0.5rem;
    width: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    color: var(--accent-color);
}
@media (min-width: 768px) {
    .reset-button:hover {
        color: var(--main-font-color);
    }
}
</style>

{#if ($screensStore.searchPanelOpened)}
    <div class="search-panel-container">
        <input id="dm-search-field" class="search-input" type="text" placeholder={$t('search.placeholder')} bind:value={searchText} on:keyup={(e) => keyupHandler(e)}>

        {#if (searchText)}
            <div class="reset-button pointer" on:click={resetHandler}>
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 20L4 4m16 0L4 20"/></svg>
            </div>
        {/if}
    </div>

    <hr class="separator">
{/if}
